import {Toolbar as RAToolbar, SaveButton} from 'react-admin';
import {alpha} from '@mui/material/styles';

export type AdminFormToolbarProps = {
    /** When set, passed to SaveButton (e.g. `"/licenses"` after dog registration save). */
    saveRedirect?: string | false;
};

/**
 * Save-only toolbar for tabbed forms (no delete).
 */
export const Toolbar = ({saveRedirect}: AdminFormToolbarProps) => {
    return (
        <RAToolbar
            sx={(theme) => ({
                display: 'flex',
                justifyContent: 'flex-end',
                gap: theme.spacing(1.5),
                flexWrap: 'wrap',
                pt: 2.5,
                mt: 1,
                borderTop: `1px solid ${alpha(theme.palette.common.black, 0.08)}`,
            })}
        >
            <SaveButton
                variant="contained"
                {...(saveRedirect !== undefined ? {redirect: saveRedirect} : {})}
            />
        </RAToolbar>
    );
};
